// Media Queries
export const MEDIA_QUERIES = {
    TABLET_OR_LARGER: '(min-width: 690px) and (min-height: 660px)',
    MOBILE_ONLY: '(max-width: 690px) or (max-height: 660px)',
} as const;

// File Types
export const FILE_TYPES = {
    COMPONENT: 'component',
    IFRAME: 'iframe',
} as const;

// File Icons
export const FILE_ICONS = {
    HTML: '🌐',
    DEFAULT: '📄',
} as const;

// Menu Icons
export const MENU_ICONS = {
    CLOSE: '✕',
    CLOSE_ALL: '🗑️',
    OPEN_RECENT: '📂',
    OUTPUT: '📋',
    EXPLORER: '📁',
    ABOUT: 'ℹ️',
    CLOSE_OTHERS: '⊘',
} as const;

// Keyboard Shortcuts (Chrome-safe)
export const KEYBOARD_SHORTCUTS = {
    CLOSE_TAB: 'Ctrl+Alt+W',
    CLOSE_ALL_TABS: 'Ctrl+Alt+Shift+W',
    TOGGLE_OUTPUT: 'Ctrl+Alt+J',
    TOGGLE_EXPLORER: 'Ctrl+Alt+E',
    OPEN_ABOUT: 'Ctrl+Shift+A',
    TOGGLE_SEARCH: 'Ctrl+Shift+F',
} as const;

// Menu Items with Shortcuts
export const MENU_ITEMS = {
    FILE: [
        {
            id: 'close',
            label: 'Close',
            shortcut: KEYBOARD_SHORTCUTS.CLOSE_TAB,
            action: 'close-tab',
        },
        {
            id: 'close-all',
            label: 'Close All',
            shortcut: KEYBOARD_SHORTCUTS.CLOSE_ALL_TABS,
            action: 'close-all-tabs',
        },
        {
            id: 'open-recent',
            label: 'Open Recent',
            action: 'open-recent',
        },
    ],
    VIEW: [
        {
            id: 'explorer',
            label: 'Explorer',
            shortcut: KEYBOARD_SHORTCUTS.TOGGLE_EXPLORER,
            action: 'toggle-explorer',
        },
        {
            id: 'output',
            label: 'Output',
            shortcut: KEYBOARD_SHORTCUTS.TOGGLE_OUTPUT,
            action: 'toggle-output',
        },
        {
            id: 'search',
            label: 'Search',
            shortcut: KEYBOARD_SHORTCUTS.TOGGLE_SEARCH,
            action: 'toggle-search',
        },
    ],
    HELP: [
        {
            id: 'about',
            label: 'About',
            shortcut: KEYBOARD_SHORTCUTS.OPEN_ABOUT,
            action: 'open-about',
        },
    ],
} as const;

// Status Messages
export const STATUS_MESSAGES = {
    LOADING: 'Loading environment...',
    READY: 'Environment loaded!',
    ERROR: 'Error loading environment',
} as const;

// UI Constants
export const UI_CONSTANTS = {
    TAB_TITLE_MAX_LENGTH: 50,
    RECENT_FILES_MAX_COUNT: 10,
    Z_INDEX: {
        MODAL: 100,
        MENU: 50,
    },
    BACKDROP_OPACITY: '50',
} as const;

// Resize Constraints (as percentages of screen dimensions)
export const RESIZE_CONSTRAINTS = {
    FILE_EXPLORER: {
        MIN_WIDTH_PERCENT: 0.1,
        MAX_WIDTH_PERCENT: 0.3,
    },
    OUTPUT_PANEL: {
        MIN_HEIGHT_PERCENT: 0.15,
        MAX_HEIGHT_PERCENT: 0.4,
    },
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
    RECENT_FILES: 'portfolio_recent_files',
    IDE_STATE: 'portfolio_ide_state',
    MOBILE_STATE: 'portfolio_mobile_state',
} as const;
